import { includes, uniq } from 'lodash';

export const VALID_ZONES = ['AB', 'ABC', 'ABCD', 'BC', 'BCD', 'CD', 'D'];

export const isValidZoneCombination = (zones, seasonalTicketZones) => {
  const zoneString = uniq(`${zones}${seasonalTicketZones}`.split(''))
    .sort((a, b) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    })
    .join('');
  return includes(VALID_ZONES, zoneString);
};

export const canAdditionalZoneBePurchased = (zones, seasonalTicketZones) =>
  isValidZoneCombination(zones, seasonalTicketZones) && // eslint-disable-line
  !includes(seasonalTicketZones, zones);

export const getAdditionalZones = (zones, seasonalTicketZones) => {
  let additionalZones = '';
  zones.split('').forEach((zoneLetter) => {
    if (!includes(seasonalTicketZones, zoneLetter)) {
      additionalZones += zoneLetter;
    }
  });
  return additionalZones;
};

export const getCombinedZones = (additionalZones, seasonalTicketZones) =>
   `${additionalZones}${seasonalTicketZones}`.split('').sort().join('') // eslint-disable-line
